
import {assign} from 'lodash';
import {Service} from './interface';


// framework 类型。用到什么了，缺什么再继续补吧。
export interface FrameworkConstants {
    userid?: string;
    agentInfo?: {
        userType: string;
    };
    verifyUser?: {
        gradeStatus?: string;
        verifyStatus: string;
        qualifyType?: string;
    };
    financeAuth?: string[];
    logoutUrl?: string;
    ticketUrl?: string;
    services?: Service[];
    SERVICE_TYPE?: Record<string, Service>;
    noOrderService?: string;
    availableService?: string;
    regionAvailable?: string[];
}

type FrameworkFlags = Record<string, any>;

type FrameworkRegion = Record<string, any>;

interface FrameworkSession {
    isAgent?: () => boolean;
    isAgentUser?: () => boolean;
}


export const CONSTANTS: FrameworkConstants = {};

export const FLAGS: FrameworkFlags = {};

export const REGION: FrameworkRegion = {};

export const SESSION: FrameworkSession = {};

export const setConstants = (sources: FrameworkConstants = {}) => {
    assign(CONSTANTS, sources);
};


export const setFlags = (sources: FrameworkFlags) => {
    assign(FLAGS, sources);
};

export const setRegion = (sources: FrameworkRegion = {}) => {
    assign(REGION, sources);
};

export const setSession = (sources: FrameworkSession = {}) => {
    assign(SESSION, sources);
};
